var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_3233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 35.9948C30.6274 35.9948 36 30.6222 36 23.9948C36 17.3673 30.6274 11.9948 24 11.9948C17.3726 11.9948 12 17.3673 12 23.9948C12 30.6222 17.3726 35.9948 24 35.9948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12H44.7812C42.6754 8.35143 39.6461 5.32154 35.9978 3.21505C32.3496 1.10855 28.2111 -0.00029387 23.9984 5.84198e-08C19.7857 0.000293987 15.6473 1.10972 11.9994 3.21672C8.35147 5.32373 5.32258 8.35403 3.21729 12.0029L13.6079 30L13.6172 29.9976C12.5602 28.1749 12.0024 26.1057 12 23.9987C11.9977 21.8917 12.5508 19.8212 13.6037 17.9961C14.6566 16.171 16.172 14.6558 17.9973 13.6031C19.8225 12.5504 21.893 11.9974 24 12Z",
    fill: "url(#paint0_linear_43_3233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 33.5C29.2467 33.5 33.5 29.2467 33.5 24C33.5 18.7533 29.2467 14.5 24 14.5C18.7533 14.5 14.5 18.7533 14.5 24C14.5 29.2467 18.7533 33.5 24 33.5Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3914 30.0028L24.0008 48C28.2134 48.0005 32.352 46.892 36.0004 44.7857C39.6487 42.6795 42.6783 39.6499 44.7843 36.0014C46.8904 32.353 47.9988 28.2143 47.9981 24.0017C47.9973 19.789 46.8874 15.6507 44.7801 12.0031H23.999L23.9965 12.0124C26.1035 12.0083 28.1744 12.5598 30.0003 13.6112C31.8263 14.6627 33.3427 16.1769 34.3969 18.0013C35.451 19.8257 36.0055 21.8958 36.0046 24.0028C36.0036 26.1099 35.4472 28.1794 34.3914 30.0028Z",
    fill: "url(#paint1_linear_43_3233)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6086 30.0031L3.21803 12.006C1.11115 15.654 0.001866 19.7924 0.001709 24.0051C0.00155201 28.2178 1.11053 32.3563 3.21713 36.0044C5.32374 39.6526 8.35371 42.6818 12.0024 44.7875C15.6511 46.8932 19.7898 48.0012 24.0025 48L34.3931 30.0029L34.3864 29.9961C33.3364 31.8228 31.8233 33.3405 29.9998 34.3961C28.1762 35.4516 26.1066 36.0078 23.9996 36.0085C21.8925 36.0092 19.8225 35.4544 17.9982 34.4001C16.174 33.3458 14.6599 31.8291 13.6086 30.0031Z",
    fill: "url(#paint2_linear_43_3233)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_3233",
    x1: 3.21729,
    y1: 15,
    x2: 44.7812,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43_3233",
    x1: 20.722,
    y1: 47.6791,
    x2: 41.504,
    y2: 11.6837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43_3233",
    x1: 26.5981,
    y1: 46.5015,
    x2: 5.81613,
    y2: 10.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_3233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.7d79fb3f6f8ca58420a99a6282999ba1.svg";
export { ForwardRef as ReactComponent };